import React, { useContext, Fragment, useState } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { SavedGigsContext } from './SavedGigsContext';
import moment from 'moment';
import freelancer from "assets/img/freelancer.jpg";
import upwork from "assets/img/upwork-icon.png";
import { Box, Text, Layer, Button, Anchor } from 'grommet';
import { Share } from 'grommet-icons';


import PoweredByGoogle from "assets/img/google/powered_by_google_on_white_hdpi.png";

const styles = {
  card: {
    minWidth: 320,
    flexGrow: 1,
    marginBottom: 20
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 6,
  },
  pos: {
   marginBottom:12,
  },
  button: {
    marginLeft: "70%"
  },
  jobBudget: {
    display: 'flex',
    marginBottom: 5,
    marginLeft: '5%',
  },
  jobTitle: {
    cursor: 'pointer'
  },
  hourlyRate: {
    marginLeft: 10
  },
  publisherImg: {
    maxWidth: 64,
    maxHeight: 64
  },
  publisher: {
    marginLeft: 'auto',
    cursor: 'pointer'
  },
  likeSection: {
    marginTop: '11px',
    marginRight: '10px',
    cursor: 'pointer',
    color: 'purple',
    '& > i': {
      fontSize: '15px',
      color: 'purple',
      marginRight: '10px',
    }
  },
  googlePic: {
    cursor: 'pointer',
    maxHeight: '14px'
  }
};

function Gig(props) {
  const [show, setShow] = React.useState();
  const savedGigsContext = useContext(SavedGigsContext)

  const { classes, gig } = props;

  const toggleIsSaved = async (gig) => {
    gig.isSaved
    ? savedGigsContext.unsaveGig(gig)
    : savedGigsContext.saveGig(gig)
  }

  const getPicForPublished = (publisher) => {
    let url = '';
    switch (publisher) {
      case 'xsu-upwork':
        url = upwork;
        break;
      case 'xsu-freelancer':
        url = freelancer;
        break;
      default:
        url = freelancer;
        break;
    }
    return url;
  }

  const formatCompensation = (min, max) => {
    const minimum = min == null ? 0 : min;
    const maximum = max == null ? 0 : max;
    let result = '';

    if (minimum > 0) {
      result = result.concat('$', minimum.toString())
    }
    if (maximum > 0) {
      if (minimum > 0) {
        result = result.concat(' - ')
      }
      result = result.concat('$', maximum.toString())
    }
    return result
  }

  const getGigSaveBlock = (showSaveBlock = false) => {
    if(!showSaveBlock) return '';
    return (
      <Fragment>
        {
          gig.isSaved ? (
            <div
              className={classes.likeSection}
              onClick={() => toggleIsSaved(gig)}
            >
              <i  className="fa fa-heart"></i>
              <p className="save-text">gig saved</p>
            </div>
          ) : (
            <div
              className={classes.likeSection}
              onClick={() => toggleIsSaved(gig)}
            >
              <i className="far fa-heart"></i>
              <p className="save-text">save gig</p>
            </div>
          )
        }
      </Fragment>
    )
  }

  return(
    <Card className={classes.card}>
      <CardContent>
        <div className="details">
          <div className={classes.jobTitle} onClick={() => setShow(true)} title={gig.seo_url}>
            <Typography variant="h6" component="h6">
              {gig.title || 'Example Title'}
            </Typography>
          </div>
          <div className={classes.jobBudget}>
            <Typography variant="h6" component="h6">
              {/*{gig.budget_minimum && gig.budget_maximum ? `$${gig.budget_minimum} - $${gig.budget_maximum}` : null}*/}
              {formatCompensation(gig.budget_minimum, gig.budget_maximum)}
              <span className={gig.budget_minimum && gig.budget_maximum ? classes.hourlyRate : ''}>{gig.type==="hourly" ? "USD per hour" : gig.type===undefined ? null : "USD"}</span>
            </Typography>
          </div>
          <div className={classes.publisher}>
            <div className={classes.jobTitle} onClick={() => setShow(true)}>
              <img src={getPicForPublished(gig.publisher)} className={classes.publisherImg}/>
            </div>
          </div>
        </div>
        <div className={classes.jobTitle} onClick={() => setShow(true)} target="_blank" title={gig.seo_url}>
          <Typography variant="body2">
            {gig.seo_url || 'http://google.com'}
          </Typography>
        </div>
        <Typography className={classes.pos} color="textSecondary">
          {gig.preview_description || 'Some lorem ipsum'}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {/*{moment.unix(gig.time_submitted).format('DD.MM.YYYY HH:mm') || 'April 1 2019'}*/}
          {gig.time_submitted.toLocaleString('en-US', { hour12: false }) || 'April 1 2019'}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {gig.location.full_address || 'New York'}
        </Typography>
        <Chip
          label={gig.status}
          className={classes.chip}
          color={gig.status === 'active' ? 'primary' : 'secondary'}
          variant="outlined"
        />
        <Box direction="row" justify="between">
          <Box
            align="center"
            direction="row"
            onClick={()=> window.open('https://cloud.google.com/solutions/talent-solution/', '_blank')}
            title="Google Cloud Talent Solution"
          >
            <img className={classes.googlePic} src={PoweredByGoogle} alt="Powered By Google"/>
            <Text margin={{left: '4px'}} size="11px" color="#777777" weight={500}>Cloud Talent Solution</Text>
          </Box>
          <Typography component="h6">
           <br />
           {gig.frontend_project_status && gig.bid_count ? `${gig.frontend_project_status} - ${gig.bid_count} bids` : null}
          </Typography>
          {getGigSaveBlock(true)}
        </Box>
      </CardContent>
      {show && (  
        <Layer
          margin="large"
          onEsc={() => setShow(false)}
          onClickOutside={() => setShow(false)}
        >
          <Box pad="large">
            <Text margin="small"><Share size="medium"/> Apply to <Anchor href={gig.seo_url} target="_blank" primary label={gig.title} /></Text>
            <Button label="close" alignSelf="center" fill={false} onClick={() => setShow(false)} />
          </Box>
        </Layer>
      )}  
    </Card>
  );

}

Gig.propTypes = { // TODO!: Set a PropTypes for every prop of every component
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Gig)
